import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApplicantDetailStepScoreCommunicationService {
  private profileUpdateSubject = new Subject<void>();
  
  profileUpdate$ = this.profileUpdateSubject.asObservable();

  requestProfileUpdate(): void {
    this.profileUpdateSubject.next();
  }
}
